import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef, Input } from '@angular/core';
import { RoleState } from 'src/app/state/roleManagement.state';
import { Observable } from 'rxjs';
import { RoleModel } from 'src/app/models/role.model';
import { Select, Store } from '@ngxs/store';
import { RoleBasedService } from 'src/app/services/role-based.service';
import { GetRoles } from 'src/app/actions/roleManagement.action';
import { getLocaleExtraDayPeriodRules } from '@angular/common';
import { Dropdown } from 'primeng/dropdown/dropdown';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { MessageServiceService } from '../../services/message-service.service'
@Component({
  selector: 'app-select-role',
  templateUrl: './select-role.component.html',
  styleUrls: ['./select-role.component.scss']
})
export class SelectRoleComponent implements OnInit {
 
  selectedRole: number;
  @Output() roleSelectEvent = new EventEmitter<GetRoles>();
  roleData: GetRoles[] =[];
  //@ViewChild('dd', {static: false}) dd: ElementRef;
  //dropDownThing: Dropdown;
  rolesForm: FormGroup; 
  
  constructor(private fb: FormBuilder,
     private roleBasedService: RoleBasedService,
     private messageService: MessageServiceService,) {
    this.create();
  }

  ngOnInit() {
  
    this.getAllRoles();
    
  }


  create(){
    this.rolesForm = this.fb.group({
      roleName: [''],
  });
  }

 
  getAllRoles(){
    this.roleBasedService.getRoles()
          .subscribe((res:any) => {
            debugger;
          if(res.response.length>0)
            this.roleData = res.response.filter(r => r.isApproved === 1);;
          }, error => {
            this.messageService.showError();
    })
  }

  sendRoleData(data) { 
    this.roleSelectEvent.emit(+data)
  }

  resetRoleForm(){
   
    this.roleData = [];
    this.getAllRoles();
  }

  setRoleThroughOtherComponent(){
    //this.rolesForm.get('roleName').setValue(val);
  }
}
